<template>

  <Modal
    :title="$t('Catho')"
    @close="cancel"
    min-height="300px"
    max-width="640px">
    <template slot="body">
      <div class="form-group">
        <label>{{ $t('UF (Estado)') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="params.catho_uf"
          maxlength="2"
          style="max-width: 4rem" />
      </div>
      <div class="form-group">
        <label>{{ $t('Cidade') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="params.catho_cidade" />
      </div>
      <div class="form-group">
        <label>{{ $t('Regime de contratação') }}</label>
        <v-select 
          v-model="regimeContratacao"
          :options="regimeContratacaoOptions" />
      </div>
      <div
        v-if="errorMessage"
        class="alert alert-warning">
        {{ errorMessage }}
      </div>
    </template>
    <template
      slot="footer">
      <div
        :class="{'box-loading': loading}">
        <button
          type="button"
          class="btn btn-light"
          @click="cancel">{{ $t('Cancel') }}</button>
        <button
          type="button"
          class="btn btn-primary"
          @click="save">{{ $t('Save') }}</button>
      </div>
    </template>
  </Modal>

</template>

<script>
import Modal from '@/components/Modal/Modal'

export default {
  name: 'JobAdvertiseBoardItemCatho',
  components: {
    Modal
  },
  props: {
    errorMessage: {
      type: [String, null]
    },
    initParams: {
      type: Object,
      default: {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      params: this.$clone(this.initParams)
    }
  },
  computed: {
    estado () {
      return [{}]
    },
    cidade () {
      return [{}]
    },
    regimeContratacaoOptions () {
      return [
        { value: 1, label: 'Autônomo' },
        { value: 2, label: 'CLT (Efetivo)' },
        { value: 5, label: 'Free-lancer' },
        { value: 6, label: 'Prestador de serviços (PJ)' },
        { value: 7, label: 'Temporário' },
        { value: 8, label: 'Trainee' }
      ]
    },
    regimeContratacao: {
      get () {
        return this.regimeContratacaoOptions.find(v => v.value === this.params.catho_regime_contratacao)
      },
      set (val) {
        this.$set(this.params, 'catho_regime_contratacao', val ? val.value : null)
      }
    }
  },
  created () {
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    save () {
      this.$emit('save', this.params)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobAdvertise/JobAdvertiseBoardsItemCatho.vue